import { VISIBLE_SIDE_DOTS } from './dot-navigation.constants';

// Validate that the page is within the visible range
export const isPageVisible = (page: number, currentPage: number): boolean => {
  const pageDifference = Math.abs(page - currentPage);
  return pageDifference >= 0 && pageDifference <= VISIBLE_SIDE_DOTS;
};
